type Props = {
  className?: string;
};

export const Sun = (props: Props) => {
  const { className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      className={className}
    >
      <g fill="#925F4B" clipPath="url(#a)">
        <path d="M12 4.207a.666.666 0 0 0 .667-.667V1.273a.666.666 0 1 0-1.334 0V3.54a.667.667 0 0 0 .667.667zm0 15.586a.667.667 0 0 0-.667.667v2.267a.667.667 0 0 0 1.334 0V20.46a.666.666 0 0 0-.667-.667zm-6.453-13.3A.667.667 0 0 0 6 6.667a.667.667 0 0 0 .473-1.14l-1.586-1.58a.667.667 0 0 0-.94.94l1.6 1.606zm12.906 11.014a.669.669 0 1 0-.946.946l1.606 1.6a.667.667 0 0 0 .474.2.667.667 0 0 0 .466-.2.667.667 0 0 0 0-.94l-1.6-1.606zM4.207 12a.667.667 0 0 0-.667-.667H1.273a.667.667 0 0 0 0 1.334H3.54A.667.667 0 0 0 4.207 12zm18.52-.667H20.46a.667.667 0 0 0 0 1.334h2.267a.667.667 0 0 0 0-1.334zm-17.18 6.174-1.6 1.606a.667.667 0 0 0 .466 1.14.666.666 0 0 0 .474-.2l1.606-1.6a.67.67 0 1 0-.946-.946zM18 6.667a.667.667 0 0 0 .473-.194l1.6-1.606a.667.667 0 0 0 0-.94.667.667 0 0 0-.94 0l-1.606 1.6A.667.667 0 0 0 18 6.667z" />
        <path d="M12.087 5.167a6.753 6.753 0 1 0 6.666 6.753 6.72 6.72 0 0 0-6.666-6.753zm0 12.166a5.42 5.42 0 1 1 5.333-5.413 5.386 5.386 0 0 1-5.333 5.413z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
